import React from "react";
import cx from "classnames";

import { Icon } from "components";
import { topologyItems } from "objs/_ConfiguratorObjs/Wizard/wizardHelpers";

export const VerticalModule = ({ classNames, title, iconName, kind }) => (
  <div className={cx("d-flex flex-column", classNames)}>
    <div className="bg-white d-flex align-items-center justify-content-center p-2">
      <Icon
        prefix="trox"
        iconName={iconName || topologyItems[kind]?.iconName}
        className="icon-32 d-flex align-items-center justify-content-center text-gray-700"
      />
    </div>
    <div className="bg-gray-700 text-white d-flex justify-content-center position-relative text-nowrap overflow-hidden">
      {title}
    </div>
  </div>
);
